import { getMonitorSource } from '@op/components/TableCommonHook/utils';
import {
  formatTime,
  transRegion,
  gameStoreRating,
  reviewerPlaytime,
  sentimentNumber,
  hideSentimentFunc,
} from '../../render-helper';
const refundedMap: any = {
  0: 'No',
  1: 'Yes',
};

function getGameStoreExtJson(
  data: any,
  key: string,
  func?: (value: any) => string,
) {
  if (data.channel_name !== 'steam') return '-';
  try {
    const obj = JSON.parse(data.ext_json);
    const value = obj[key];
    if (value && !func) return value;
    if (func) return func(value);
    return value || '-';
  } catch (error) {
    return '-';
  }
}

function dealwithSteamStore(value: number) {
  return value === 1 ? 'Yes' : 'No';
}

function dealwithSteamStarred(value: number) {
  return value === 1 ? 'No' : 'Yes';
}

function dealwithMonitorSource(data: any, key: string) {
  const list = (data[key] || [])
    .map((item: any) => {
      return getMonitorSource(item);
    })
    .filter(Boolean);

  return list.join(', ');
}

export default function gameStoreColumnsFunc(params: any) {
  const { entity_type: gameType, hideSentimentRating } = params;

  const list = [
    { header: 'comment_uin', render: 'comment_uin' },
    { header: 'channel', render: 'channel_name' },
    {
      header: 'rating',
      render: 'comment_score',
      renderHelper: [gameStoreRating],
    },
    {
      header: 'Sentiment',
      render: 'sentiment_rating',
      width: 10,
      renderHelper: [hideSentimentRating ? hideSentimentFunc : sentimentNumber],
      numFmt: ['0.00'],
    },
    { header: 'Reviewer', render: 'reviewer' },

    { header: 'On Record Time(hours)', render: 'on_record_time', renderHelper: [reviewerPlaytime] },
    { header: 'At Review Time(hours)', render: 'at_review_time', renderHelper: [reviewerPlaytime] },
    {
      header: 'Content_Original',
      render: 'content',
    },
    {
      header: 'Content_Chinese',
      render: 'content_to_zh',
    },
    {
      header: 'Content_English',
      render: 'content_to_en',
    },
    {
      header: 'Monitor Source',
      render: 'monitor_source',
      renderHelper: [dealwithMonitorSource],
    },
    {
      header: 'Date',
      render: 'comment_time',
      renderHelper: [formatTime('YYYY-MM-DD')],
    },
    {
      header: 'Time(UTC+8:00)',
      render: 'comment_time',
      renderHelper: [formatTime('YYYY-MM-DD HH:mm:ss')],
    },
    {
      header: 'Language',
      render: 'language',
      renderHelper: [transRegion(3)],
    },
    { header: 'Topic', render: 'topic' },
    ...(gameType === 'pc'
      ? [
        {
          header: 'Refunded',
          render: 'refunded',
          renderHelper: [
            (
              item: { [x: string]: string | number },
              key: string | number,
            ) => {
              if (item?.channel_name === 'steam') {
                return refundedMap[item[key]];
              }
            },
          ],
        },
        {
          header: 'SteamId',
          render: 'user_id',
          renderHelper: [
            (item: { [x: string]: string | number }, key: string) => {
              return getGameStoreExtJson(item, key);
            },
          ],
        },
        {
          header: 'Starred Tag',
          render: 'unstarred',
          renderHelper: [
            (item: { [x: string]: string | number }, key: string) => {
              return getGameStoreExtJson(item, key, dealwithSteamStarred);
            },
          ],
        },
        {
          header: 'Free Played',
          render: 'received_free',
          renderHelper: [
            (item: { [x: string]: string | number }, key: string) => {
              return getGameStoreExtJson(item, key, dealwithSteamStore);
            },
          ],
        },
        {
          header: 'Steam Purchase',
          render: 'steam_purchase',
          renderHelper: [
            (item: { [x: string]: string | number }, key: string) => {
              return getGameStoreExtJson(item, key, dealwithSteamStore);
            },
          ],
        },
        {
          header: 'Early Access Reviews',
          render: 'received_free',
          renderHelper: [
            (item: { [x: string]: string | number }, key: string) => {
              return getGameStoreExtJson(item, key, dealwithSteamStore);
            },
          ],
        },
        {
          header: 'Funny(people)',
          render: 'funny_num',
          renderHelper: [
            (item: { [x: string]: string | number }, key: string) => {
              return getGameStoreExtJson(item, key);
            },
          ],
        },
        {
          header: 'Helpful(people)',
          render: 'helpful_num',
          renderHelper: [
            (item: { [x: string]: string | number }, key: string) => {
              return getGameStoreExtJson(item, key);
            },
          ],
        },
      ]
      : []),
    { header: 'market', render: 'market', renderHelper: [transRegion(1)] },
    { header: 'version', render: 'version' },
    { header: 'URL', render: 'content_url' },
  ];

  return list;
}
